<div  *ngIf="loader" class="spinner-wrapper">
    <mis-loader [mobileView]="false"></mis-loader>
</div>
<div *ngIf="!loader" class="d-flex main">
    <div class="side-bar-btn-box" [ngClass]="{'closed': !showSideBar}">
        <app-side-bar-tr [adhoc_text]="adhoc_text"></app-side-bar-tr>
        <div class="close_btn" id="left_pane_close_btn" (click)="toggleSideBar()" [ngClass]="{'closed': !showSideBar}"></div>
    </div>
    <div class="map-player-container"  *ngIf="!loader">
        <app-map-view (reStart)="getMilestones()" [driverData]="driverData"></app-map-view>
        <app-trip-player [driverData]="driverData" ></app-trip-player>
    </div>
</div>